import React from "react";
import "../styles/layout.css";

export const Footer = () => {
  return (
    <footer className="footer text-center py-3 mt-auto">
      <div className="container">
        <small>
          © {new Date().getFullYear()} Analítica de Inventario por Alejandro Roca
        </small>
      </div>
    </footer>
  );
};

export default Footer;
